// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
    production: false,
    demo: 'default',
    url_storage: 'https://md-educa.s3.sa-east-1.amazonaws.com/',
    urlBase: 'https://develop-api.mitsat.com.br/api',
    ambiente: null,
    googleMapsApiKey: 'AIzaSyASyrv2ekhhFpQj-zogApfNlXoIi_jlL0M'
};
 